import { useEffect, useRef } from 'react';
import { useFrontendAuth } from '../hooks/useAuth';
import { useTranslation } from '../context/TranslationContext';

/**
 * Account settings (preferredLanguage) beat a leftover localStorage guest value.
 * Guest localStorage is only used to fill an empty profile.
 * Header switcher / settings still write both (explicit choice).
 */
export default function PreferredLanguageSync() {
    const { user, isAuthReady } = useFrontendAuth();
    const { changeLanguage } = useTranslation();
    const syncedUserId = useRef<string | null>(null);

    useEffect(() => {
        if (!isAuthReady) return;

        if (!user?.id) {
            syncedUserId.current = null;
            return;
        }

        if (syncedUserId.current === user.id) return;
        syncedUserId.current = user.id;

        const storedLang = localStorage.getItem('language');

        if (user.preferredLanguage) {
            if (user.preferredLanguage !== storedLang) {
                void changeLanguage(user.preferredLanguage, { persist: false });
            }
            return;
        }

        if (storedLang) {
            void changeLanguage(storedLang, { persist: true });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per user id, not on every changeLanguage identity
    }, [isAuthReady, user?.id, user?.preferredLanguage]);

    return null;
}